import React from 'react'

import AboutSection from './about-section'

const AboutPage = () => <AboutSection />

export default AboutPage
